import { type FC, type RefObject } from 'react';
import { type TileSize } from './constants.ts';
import { useTileSizeClassNames } from './hooks/useTileSizeClassNames.ts';
import classNames from 'classnames';
import styles from './styles/styles.scss';
import dibsCss from 'dibs-css';

const ShimmerLine: FC<{ dataTn: string; className: string }> = ({ dataTn, className }) => (
    <div
        data-tn={dataTn}
        className={classNames(styles.shimmer, dibsCss.rounded2px, dibsCss.mbXsmall, className)}
    />
);

type Props = {
    size: TileSize;
    visibilityRef?: RefObject<HTMLDivElement | null>;
};

export const BuyerProductTileShimmer: FC<Props> = ({ size, visibilityRef }) => {
    const { tileSizeClassNames, productImageClassNames } = useTileSizeClassNames({ size });

    return (
        <div className={classNames(tileSizeClassNames, dibsCss.wFull)} ref={visibilityRef}>
            <ShimmerLine dataTn="product-image" className={productImageClassNames} />
            <ShimmerLine dataTn="product-title-line-1" className={dibsCss.h18px} />
            <ShimmerLine dataTn="product-title-line-2" className={dibsCss.h18px} />
            <ShimmerLine
                dataTn="product-pricing"
                className={classNames(dibsCss.h18px, dibsCss.w25)}
            />
        </div>
    );
};
